<h2>Users
  @if (selectedStore) {
    <a routerLink="/stores/{{selectedStore.slug}}" class="btn btn-light btn-sm">
      < Back to {{ selectedStore.name }}
    </a>
  }
</h2>

<div class="row center-align-children mt-3 mb-3">
  <div class="col">
    <input class="form-control"
      id="users-search"
      type="text"
      placeholder="Search for user"
      [(ngModel)]="searchModel">
  </div>
</div>

<div class="row">
  @for (userSummary of userSummaries
    | listFilter: searchModel: 'email'
    | slice: (page-1) * pageSize : page * pageSize; track userSummary) {
    <div
      class="user-summary col-md-3 m-2 float-start">
      <a routerLink="/users/{{userSummary.email}}">{{ userSummary.email }}</a>
    </div>
  }
</div>

<ngb-pagination
  [(page)]="page"
  [pageSize]="pageSize"
  [collectionSize]="(userSummaries | listFilter: searchModel: 'email').length">
</ngb-pagination>
